export default __webpack_public_path__ + "static/media/previous.2a2b3083.svg";